import { Box, Typography } from "@mui/material";
import DriveshaftToleranceWidget from "../../Widgets/Tolerance/Driveshaft/Driveshaft";
import { useTranslation } from "react-i18next";

const DriveshaftTolerancePage = () => {
  return (
    <Box >
      <Typography m={3} variant="h3">Driveshaft</Typography>
      <DriveshaftToleranceWidget />
    </Box>
  );
};

export default DriveshaftTolerancePage;
